import pagesNames from "../../../constants/pages-names";

const socialPageData = {
    mainHeader : "Social Impact",
    borderSection : {
        title : "Overarching goal",
        subtitle : "Play a leading role to shape an inclusive and diverse society, positively impacting our stakeholders",
    },
    paragraphOne : "The social aspect of our ESG strategy seeks to create long-term social impacts on society. To achieve this ideal, our social development projects incorporate a wide scope of human development activities. In a world beset with inequalities, we are making our contribution to restoring human dignity by supporting basic needs and empowering marginalised members of society with survival skills.",
    paragraphTwo : "The UNSDGs espouse that no one should be left behind in human development. SAB’s organisational value of inclusion and diversity resonates with this call. SAB supports inclusivity through social projects that empower women and the para-abled. We are also conscious that other segments of our society, such as the underprivileged, should not be left behind. To this end, we help support the disabled, low-income families, widows and orphans, and children with special needs. ",
    paragraphThree : "Our mission is also to go beyond basic needs to ensure that people’s dreams and hopes are realised. Skills empowerment drives are at the heart of our approach to empowering individuals and groups in society. We participate in entrepreneurial skills development initiatives that support the corporate business leaders emerging from the MSME ranks of the Kingdom, especially youth and women.",
    sectionOne : {
        title : "Focus Areas",
        cards : [
            {
                icon : "two-hands.svg",
                title : "Diversity",
                subtitle : "Women and para-abled empowerment",
            },
            {
                icon : "hand-shaking.svg",
                title : "Closing the regional savings gap",
                subtitle : "Education and financial literacy",
            },
            {
                icon : "esg.svg",
                title : "Advancing the ESG and sustainable finance market",
                subtitle : "Stakeholder engagement",
            },
            {
                icon : "digital.svg",
                title : "Digitalisation to support customers’ sustainable finance journey",
                subtitle : "Access to financial services and cyber security",
            },
        ]
    },
    flexViewSection : [
        {
            image : {
                name : "img-2.jpg",
                alt : "Light Cross the trees",
            },
            title : "Social Impact",
            subtitle : "Play a leading role to shape an inclusive and diverse society, positively impacting our stakeholders",
            button : {
                text : "Read More",
                path : pagesNames.home
            }
        },
        {
            image : {
                name : "img-5.jpg",
                alt : "a person using a laptop",
            },
            title : "Overarching Goal",
            subtitle : "Commitment towards a high standard of governance, driving integrity and responsibility in all decision-making.",
            button : {
                text : "Read More",
                path : pagesNames.home
            }
        },
        {
            image : {
                name : "img-4.jpg",
                alt : "A woman helps a child",
            },
            title : "Sustainability in Our Operations",
            subtitle : "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim",
            button : {
                text : "Read More",
                path : pagesNames.home
            }
        },
    ],
    tabsView : {
        titles : [
            "Diversity",
            "Closing the regional savings gap",
            "Advancing the ESG and sustainable finance market",
            "Digitalisation",
            "Community initiatives",
            "Our workforce: The bedrock of our success",
        ],
    }
}

export default socialPageData;